/**
 * File: leadFieldsUtils.ts
 * Path: apps/admin/src/shared/utils/leadFieldsUtils.ts
 * Description: The checks shared by the Add lead form and the lead details
 * form, so both accept and reject the same input.
 */

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** "R 12 500" or "12,500.50" → 12500.5; empty → null; anything else → NaN. */
export const parseRand = (raw: string): number | null => {
  const cleaned = raw.replace(/[R\s,]/gi, "");
  return cleaned ? Number(cleaned) : null;
};

export type LeadFieldErrors = Partial<Record<"name" | "email" | "value", string>>;

export const validateLeadFields = (fields: {
  name: string;
  email: string;
  value: string;
}): LeadFieldErrors => {
  const errors: LeadFieldErrors = {};
  if (!fields.name.trim()) errors.name = "Add the business name.";
  if (fields.email.trim() && !EMAIL.test(fields.email.trim())) {
    errors.email = "That email address doesn't look right.";
  }
  const value = parseRand(fields.value);
  if (value !== null && (!Number.isFinite(value) || value < 0)) {
    errors.value = "Enter an amount in rand, like 12500.";
  }
  return errors;
};
